import MatCheckbox, {
  CheckboxProps as MatCheckboxProps,
} from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormGroup from "@mui/material/FormGroup"
import FormHelperText from "@mui/material/FormHelperText"

import DOMPurify from "dompurify"
import React, { FC } from "react"

import { create } from "src/helpers/bem"

import styles from "./Checkbox.module.scss"

const bem = create(styles, "Checkbox")

export type CheckboxProps = {
  variant?: "standard" | "filled" | "outlined"
  helperText?: string
  errorText?: string
  label?: string
  isValid?: boolean
  useRichText?: boolean
} & MatCheckboxProps

export const Checkbox: FC<CheckboxProps> = ({
  value = false,
  variant = "filled",
  checked = false,
  useRichText = false,
  label,
  isValid,
  required,
  helperText,
  errorText,
  ...props
}) => {
  return (
    <FormControl
      required
      component="fieldset"
      className={bem(undefined, isValid ? undefined : "invalid")}
      error={!!errorText}
      variant={variant}
    >
      <FormGroup>
        <FormControlLabel
          control={<MatCheckbox checked={checked} {...props} value={value} />}
          label={
            !useRichText ? (
              label
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(label ?? "", {
                    ADD_ATTR: ["target"],
                  }),
                }}
              ></div>
            )
          }
        />
      </FormGroup>
      {errorText ||
        (helperText && (
          <FormHelperText className={bem("helperText")}>
            {errorText ?? helperText}
          </FormHelperText>
        ))}
    </FormControl>
  )
}
